export const formatTL = (n, opts = {}) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency', currency: 'TRY',
    minimumFractionDigits: opts.decimals ? 2 : 0,
    maximumFractionDigits: opts.decimals ? 2 : 0,
  }).format(v);
};

export const formatNum = (n) => new Intl.NumberFormat('tr-TR').format(Number(n || 0));

export const formatDate = (iso) => {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });
  } catch { return '-'; }
};

export const formatDateShort = (iso) => {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short' });
  } catch { return '-'; }
};

export const monthLabel = (mk) => {
  if (!mk) return '-';
  const [y, m] = mk.split('-');
  const names = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  return `${names[parseInt(m, 10) - 1]} ${y}`;
};

export const TIER_COLORS = {
  Bronze: '#CD7F32',
  Silver: '#9CA3AF',
  Gold: '#A9793D',
  Diamond: '#5DAECD',
};

export const STATUS_LABELS = {
  pending: 'Onay bekleyen',
  confirmed: 'Onaylandı',
  approved: 'Onaylandı',
  paid: 'Ödendi',
  reversed: 'İptal edildi',
  returned: 'İade edildi',
  recorded: 'Kaydedildi',
};
